import { ReactNode } from "react";
import { View, TouchableOpacity, StyleSheet } from "react-native";
import { ChevronDown } from "lucide-react";
import CustomText from "../CustomText/CustomText";
import { colors } from "../../../../styles/design-system";

interface SettingsAccordionItemProps {
  icon: ReactNode;
  title: string;
  rightLabel?: string;
  children?: ReactNode;
  isLast?: boolean;
  expanded?: boolean;
  onToggle?: () => void;
  index?: number;
}

const SettingsAccordionItem = ({
  icon,
  title,
  rightLabel,
  children,
  isLast = false,
  expanded,
  onToggle,
  index = 0,
}: SettingsAccordionItemProps) => {
  const zIndex = 50 - index * 10;
  return (
    <View style={[styles.item, expanded && { zIndex }, !isLast && styles.borderBottom]}>
      <TouchableOpacity onPress={onToggle} style={styles.header} activeOpacity={0.8}>
        <View style={styles.left}>
          <View style={styles.icon}>{icon}</View>
          <CustomText style={{}} useTranslationText={false} text={title} size="s" weight="bold" />
        </View>

        <View style={styles.right}>
          {rightLabel && <CustomText style={{}} useTranslationText={false} text={rightLabel} size="xs" />}

          <ChevronDown
            size={16}
            style={{
              transition: "transform 0.2s ease",
              transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
            }}
          />
        </View>
      </TouchableOpacity>

      {expanded && children && <View style={styles.content}>{children}</View>}
    </View>
  );
};

const styles = StyleSheet.create({
  item: {
    position: "relative",
  },
  borderBottom: {
    borderBottomWidth: 1,
    borderBottomColor: colors.grey[200],
  },
  header: {
    paddingHorizontal: 24,
    paddingVertical: 16,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  left: {
    flexDirection: "row",
    alignItems: "center",
    gap: 10,
    flex: 1,
  },
  icon: {
    opacity: 0.7,
  },
  right: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
  },
  content: {
    paddingHorizontal: 24,
    paddingBottom: 16,
    zIndex: 100,
  },
});

export default SettingsAccordionItem;
